import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.userForAgentAssignment.DOC}
  query UsersForAgentAssignmentInZone(
    $zoneId: ID!
    $tenantId: ID!
    $ids: [ID!]
    $quantity: Int
    $cursor: String
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        users(ids: $ids, quantity: $quantity, cursor: $cursor) {
          items {
            info {
              ...FragmentUserForAgentAssignment
            }
            zoneAccess
          }
          nextCursor
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.UsersForAgentAssignmentInZoneQuery,
    ents.core.common.Response.For.Pagination<models.User>,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'users',
        graphql.transformers.OUT.object({
          items: graphql.transformers.OUT.default(
            graphql.transformers.OUT.list(
              graphql.transformers.OUT.custom(user => {
                TypeAsserter.assertIsNotNullish(user?.info)
                return {
                  ...fragments.userForAgentAssignment.TRANSFORMER.getEntityFrom(
                    user.info,
                  ),
                  id: user.info.id ?? undefined,
                  isPlatformAdmin: user.info.isPlatformAdmin ?? undefined,
                  name:
                    user.info.firstName && user.info.lastName
                      ? `${user.info.firstName} ${user.info.lastName}`
                      : (user.info.firstName ??
                        user.info.lastName ??
                        'Unknown User'),
                }
              }),
              { onNullish: 'remove' },
            ),
            [],
          ),
          nextCursor: () => undefined,
        }),
      ),
    ),
  ),
  { items: [], nextCursor: undefined },
)

export const execute = graphql.createExecutor<
  graphql.schema.UsersForAgentAssignmentInZoneQuery,
  ents.core.common.Response.For.Pagination<models.User>,
  graphql.schema.UsersForAgentAssignmentInZoneQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
